import { useMemo } from 'react';
import { PolicyActionEnum } from '@trinity/access-policy';
import { useCan } from '@trinity/access-policy/react';
import type { BrandInsightsCapabilities } from '@trinity/chat/types/capabilities';

export const useBrandInsightsCapabilities = (): BrandInsightsCapabilities => {
  // UI gating only: chat-api strips trace links from responses for callers without this action.
  const canViewTraces = useCan(PolicyActionEnum.ChatTraceView);

  return useMemo(
    () => ({
      canApplyFilters: false,
      canViewTraces,
      canViewExternalLinks: true,
      canAddToDashboard: true,
    }),
    [canViewTraces]
  );
};
